export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLEAN_NOTIFICATION = 'CLEAN_NOTIFICATION';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
